import { ChangeDetectionStrategy, Component, DestroyRef, Inject, inject, OnInit } from '@angular/core';
import {HlrCurrencies } from '@helpers/types/models';
import { FormControl, FormGroup } from '@angular/forms';
import { AlarisEditPanelService, EditPanelInputData } from '@campaign-portal/components-library';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CurrenciesService } from '../currencies.service';
import type { AvailableIcons } from '@alarislabs/icons';

@Component({
	selector: 'app-edit-currency',
	templateUrl: './edit-currency.component.html',
	styleUrl: './edit-currency.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class EditCurrencyComponent implements OnInit {
	readonly errors: { key: string; value: string }[] = [
		{key: 'mask', value: 'gl.errors.invalid_format'},
		{key: 'required', value: 'gl.errors.required'}];
	readonly currency: HlrCurrencies = {
		id: null,
		name: '',
		charCode: '',
		currencySymbol: '',
		isSystemCurrency: false,
		currencyIconName: ''
	};
	readonly currencyForm = new FormGroup({
		id: new FormControl(),
		name: new FormControl(),
		charCode: new FormControl(),
		currencySymbol: new FormControl(),
		isSystemCurrency: new FormControl(),
		currencyIconName: new FormControl()
	});
	readonly flagIcons: (AvailableIcons | '')[] = [
		'',
		'icon-EUR',
		'icon-US',
		'icon-RU',
		'icon-JP',
		'icon-CN',
		'icon-TR',
		'icon-AE',
		'icon-IN',
		'icon-AR',
		'icon-BR'
	]

	readonly separator = ', ';
	private readonly destroyRef = inject(DestroyRef);

	constructor(
		@Inject(EditPanelInputData) private readonly inputData: { currency?: HlrCurrencies },
		public readonly currenciesService: CurrenciesService,
		private readonly editPanel: AlarisEditPanelService
	) {
		if ( this.inputData.currency ) {
			this.currency = this.inputData.currency;
		}
	}

	ngOnInit(): void {
		this.reset();
	}

	reset(): void {
		const currency = structuredClone(this.currency);
		this.currencyForm.reset(currency);
	}

	save(): void {
		const currency: HlrCurrencies = {
			id: this.currencyForm.controls.id.value,
			name: this.currencyForm.controls.name.value,
			charCode: this.currencyForm.controls.charCode.value,
			currencySymbol: this.currencyForm.controls.currencySymbol.value,
			isSystemCurrency: this.currencyForm.controls.isSystemCurrency.value,
			currencyIconName: this.currencyForm.controls.currencyIconName.value
		};
		this.currenciesService.update(currency)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((resp) => {
				if (
					resp.data[0]?.id
				) {
					this.editPanel.close(true);
				}
			});
	}

	close(): void {
		this.editPanel.close(false);
	}
}
